import { render, staticRenderFns } from "./CodeFindRulesDetailView.vue?vue&type=template&id=37674628&scoped=true"
import script from "./CodeFindRulesDetailView.vue?vue&type=script&lang=js"
export * from "./CodeFindRulesDetailView.vue?vue&type=script&lang=js"
import style0 from "./CodeFindRulesDetailView.vue?vue&type=style&index=0&id=37674628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37674628",
  null
  
)

export default component.exports